import axiosConfig from "./axiosConfig";

interface PVDataListResponse {
  // BMA now returns `summary: null` (200) when no data has been uploaded yet
  // — a legitimate state, not an error (see ADMIN-APP-52).
  summary: {
    sites_verified: number;
    zero_panels?: any[];
    map_render_failed?: any[];
    below_bounds?: any[];
    above_bounds?: any[];
    [key: string]: any;
  } | null;
  [key: string]: any;
}

const getPVDataList = async (
  authToken: string
): Promise<PVDataListResponse> => {
  const { data } = await axiosConfig.get(`/reports/pv-design/site`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getPVDataList;
